// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__RQz99","selected":"Tag_selected__fj8eG"};